import React from 'react';
import { useHistory } from 'react-router-dom';
import Restricted from '../authorization/Restricted';
import { SHOW_DEPLOYMENTS_PERMISSION, SHOW_PLATFORM_HEALTH } from '../utils/constants';

/**
 * Component that handles the default route logic:
 * 1. If user has SHOW_DEPLOYMENTS_PERMISSION -> redirect to /home (Home Page)
 * 2. If user doesn't have SHOW_DEPLOYMENTS_PERMISSION but has SHOW_PLATFORM_HEALTH -> redirect to /platformHealth
 * 3. Otherwise -> show nothing (will redirect)
 */
const DefaultRouteHandler = () => {
  const history = useHistory();

  // Redirect to Home Page
  const HomeRedirect = () => {
    React.useEffect(() => {
      history.replace('/home');
    }, []);
    
    return null;
  };

  // Fallback component that redirects to platform health
  const PlatformHealthRedirect = () => {
    React.useEffect(() => {
      history.replace('/platformHealth');
    }, []);
    
    return null; // Don't render anything while redirecting
  };

  return (
    <Restricted 
      to={[SHOW_DEPLOYMENTS_PERMISSION]} 
      fallback={
        <Restricted to={[SHOW_PLATFORM_HEALTH]}>
          <PlatformHealthRedirect />
        </Restricted>
      }
    >
      <HomeRedirect />
    </Restricted>
  );
};

export default DefaultRouteHandler;